export const BadgesLoading = ({ isEvenIndex }: { isEvenIndex: boolean }) => {
  return (
    <div
      className="flex flex-row items-center self-start gap-3 animate-pulse"
      style={{ animationDelay: isEvenIndex ? "-1.5s" : "-.5s" }}
    >
      <div className="flex items-center p-2 space-x-2 bg-bg-base border border-subtle rounded-md">
        <div className="w-3 h-3 bg-bg-subtle rounded-xl" />
        <div className="bg-bg-subtle h-3 w-[100px] rounded-xl" />
      </div>
      <div className="flex items-center p-2 space-x-2 bg-bg-base border border-subtle rounded-md">
        <div className="w-3 h-3 bg-bg-subtle rounded-xl" />
        <div className="bg-bg-subtle h-3 w-[56px] rounded-xl" />
      </div>
    </div>
  );
};
